import { IRestClient } from '../clients/RestClient';
import { IAuthService } from './AuthService';
import {
  IForgotPasswordRequest,
  IForgotPasswordResponse,
  ILoginRequest,
  ILoginResponse,
  IRefreshTokenResponse,
  IResetPasswordRequest,
  IResetPasswordResponse,
  ISessionResponse,
} from './UserService.interface';

export interface IUserService {
  getSession(): Promise<ISessionResponse>;
  login(request: ILoginRequest): Promise<ILoginResponse>;
  logout(): Promise<void>;
}

export class UserService implements IUserService {
  constructor(
    private restClient: IRestClient,
    private authService: IAuthService,
  ) {
    this.restClient = restClient;
    this.authService = authService;
  }

  public async getSession(): Promise<ISessionResponse> {
    const response: ISessionResponse = await this.restClient.get(
      '/v2/user/sessions',
      {},
    );
    return response;
  }

  public async refreshToken() {
    const _refreshToken = this.authService.getToken('refresh-token');
    const refreshToken = _refreshToken.replace('Bearer ', '');

    const response: IRefreshTokenResponse = await this.restClient.post(
      '/v1/auth/refresh-token',
      {
        data: {
          refreshToken,
        },
      },
    );

    if (response.statusCodes === 200) return response;
  }

  public async login(request: ILoginRequest): Promise<ILoginResponse> {
    const response: ILoginResponse = await this.restClient.post(
      '/v1/auth/login',
      {
        data: request,
      },
    );
    return response;
  }

  public async logout(): Promise<void> {
    this.authService.removeToken('access-token');
    this.authService.removeToken('refresh-token');
  }

  public async forgotPassword(
    request: IForgotPasswordRequest,
  ): Promise<IForgotPasswordResponse> {
    const response: IForgotPasswordResponse = await this.restClient.post(
      '/v1/auth/password/reset/sendmail',
      {
        data: request,
      },
    );
    return response;
  }

  public async resetPassword(
    request: IResetPasswordRequest,
  ): Promise<IResetPasswordResponse> {
    const response: IResetPasswordResponse = await this.restClient.post(
      '/v1/auth/password/reset',
      {
        data: request,
      },
    );
    return response;
  }
}
